/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/services/executionWorkspaceService.js
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Service layer for Execution Workspace.
 *
 * During Phase-1 this service returns mock data.
 * During Phase-2 it will call backend APIs without
 * changing the UI implementation.
 *
 ******************************************************************************/

//import mockExecutionWorkspace from "../mock/mockExecutionWorkspace";

// ============================================================================
// EXECUTION WORKSPACE SERVICE
// ============================================================================

import axiosClient from "../../../../../api/axiosClient";
const executionWorkspaceService = {

    // ==========================================================
    // LOAD WORKSPACE
    // ==========================================================

    async getExecutionWorkspace(workId) {

    const response = await axiosClient.get(
        `/api/wms/works/${workId}/execution`
    );

    return response.data.data;

},
    // ==========================================================
    // SAVE PROGRESS
    // ==========================================================

    async saveProgress(payload) {

        console.log("Save Progress", payload);

        return {

            success: true,

            message: "Progress saved successfully.",

        };

    },

    // ==========================================================
    // COMPLETE WORK
    // ==========================================================

    // ==========================================================
    // COMPLETE WORK
    // ==========================================================

    async completeWork(
        workId,
        completionRemarks = ""
    ) {

        const response = await axiosClient.post(

            `/api/wms/works/${workId}/complete`,

            {
                completion_remarks: completionRemarks
            }

        );

        return response.data.data;

    },

    // ==========================================================
    // UPDATE CHECKLIST ITEM
    // ==========================================================

    async updateChecklistItem(
    workId,
    workChecklistItemId,
    payload
) {

    const response = await axiosClient.put(

            `/api/wms/works/${workId}/checklist-item/${workChecklistItemId}`,

            payload

        );

        return response.data.data;

    },

    // ==========================================================
    // ADD OBSERVATION
    // ==========================================================

    async addObservation(payload) {

        console.log("Observation", payload);

        return {

            success: true,

        };

    },

    // ==========================================================
    // ADD COMMENT
    // ==========================================================

    // ==========================================================
    // ADD COMMENT
    // ==========================================================

    async addComment(
        workId,
        commentText
    ) {

        const response = await axiosClient.post(

            `/api/wms/works/${workId}/comments`,

            {
                comment_text: commentText
            }

        );

        return response.data.data;

    },
    // ==========================================================
    // UPLOAD ATTACHMENT
    // ==========================================================

    async uploadAttachment(formData) {

        console.log("Attachment", formData);

        return {

            success: true,

        };

    },

};

export default executionWorkspaceService;